const navbarHeight = 50;
const freePlanHeight = 22;
const minConsoleHeight = 30;

export { navbarHeight, freePlanHeight, minConsoleHeight };
